import script from "./previewTax.vue?vue&type=script&setup=true&lang=js"
export * from "./previewTax.vue?vue&type=script&setup=true&lang=js"

import "./previewTax.vue?vue&type=style&index=0&id=01317b04&scoped=true&lang=css"

import exportComponent from "/Users/saameen/Documents/www/hs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01317b04"]])

export default __exports__